// assets
import { IconCertificate, IconRosetteDiscountCheck, IconShieldCheck } from '@tabler/icons-react';

// types
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS - CERTIFICATION (P2-1) ||============================== //

const certification: NavItemType = {
  id: 'certification',
  title: 'certification', // react-intl key - i18n-ready [STD-DRIFT]
  icon: IconCertificate,
  type: 'group',
  requiredModule: 'certification',
  children: [
    {
      id: 'certification-templates',
      title: 'certification-templates',
      icon: IconCertificate,
      type: 'item',
      url: '/certification/templates',
      module: 'certification.templates'
    },
    {
      id: 'certification-issued',
      title: 'certification-issued',
      icon: IconRosetteDiscountCheck,
      type: 'item',
      url: '/certification/certificates',
      module: 'certification.certificates'
    },
    {
      id: 'certification-verify',
      title: 'certification-verify',
      icon: IconShieldCheck,
      type: 'item',
      url: '/certification/verify',
      // verify anonim uç — izin etiketi yok (herkes doğrulayabilir)
    }
  ]
};

export default certification;
